<div class="main_dialog sm_dialog">
  <div class="dialog_title">
    <h2>{{ 'Sync Calender' | translate}}</h2>
    <button class="dialog_close" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog_body">
    <div class="btn_list">
      <button class="btnn">
        <img src={{assetsConst.googleCalender}} alt="open Image"> Google Calendar
      </button>
      <button class="btnn">
        <img src={{assetsConst.outlookCalender}} alt="open Image"> Outlook Calendar
      </button>
     
    </div>
  </div>
</div>